import React from "react";
import { Paper, Typography, Grid } from "@material-ui/core";

const ScoreBoard = ({ currentPeriod, gameStats, teamAInfo, teamBInfo }) => {
    return (
        <Paper style={{ padding: 10, marginTop: 10, backgroundColor: "#e0e0e0" }}>
            {/* <Typography variant="h6" align="center" gutterBottom>
                Marcador del Partido
            </Typography> */}

            <Grid container spacing={4} alignItems="center" justify="center">
                <Grid item xs={4} sm={4}>
                    <Typography variant="subtitle1" align="center">
                        {teamAInfo.name || "Equipo A"}
                    </Typography>
                    <Typography variant="h3" align="center">
                        {gameStats?.A?.totalPuntos || 0}
                    </Typography>
                    <Typography align="center">
                        Faltas totales: {gameStats?.A?.faltas || 0}
                    </Typography>
                    <Typography align="center">
                        Faltas del periodo: {gameStats?.A?.faltasPorcuarto[currentPeriod] || 0}
                    </Typography>
                </Grid>

                <Grid item xs={4} sm={4}>
                    <Typography variant="subtitle1" align="center">
                        Periodo
                    </Typography>
                    <Typography variant="h4" align="center">
                        {currentPeriod}
                    </Typography>
                </Grid>

                <Grid item xs={4} sm={4}>
                    <Typography variant="subtitle1" align="center">
                        {teamBInfo.name || "Equipo B    "}
                    </Typography>
                    <Typography variant="h3" align="center">
                        {gameStats?.B?.totalPuntos || 0}
                    </Typography>
                    <Typography align="center">
                        Faltas totales: {gameStats?.B?.faltas || 0}
                    </Typography>
                    <Typography align="center">
                        Faltas del periodo: {gameStats?.B?.faltasPorcuarto[currentPeriod] || 0}
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default ScoreBoard;
